module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "c2",
    attrs: {
      "id": "calibre_pb_0"
    }
  }, [_vm._v("Smashwords Edition, License Notes")]), _vm._v(" "), _c('p', {
    staticClass: "c3"
  }, [_vm._v("This book is licensed for your personal enjoyment\nonly. This ebook may not be resold or given away to other people.\nIf you would like to share this book with another person, please\npurchase an additional copy for each recipient. If you’re reading\nthis book and did not purchase it, or it was not purchased for your\nuse only, then please return to your favorite ebook retailer and\npurchase your own copy. Thank you for respecting the hard work of\nthis author.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b9ab52c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_001.vue
// module id = 60
// module chunks = 0